import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../../services'

@Component({
    selector: 'app-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.css'],
})

export class DocumentComponent implements OnInit {
    en: any = {}
    showEN = true
    documentItems: Array<DocumentItem> = [
        { name: 'tutorial', url: '/tutorial', icon: 'ion-document' },
        {
            name: 'tutorial_v',
            url: 'https://sites.google.com/view/orthocomm-tutorial/%E3%83%9B%E3%83%BC%E3%83%A0',
            icon: 'ion-document',
        },
        {
            name: 'privacy_policy',
            url: '/privacy_statement/policy.html',
            icon: 'ion-alert',
        },
    ]

    constructor(public authData: AuthService) {
    }

    ngOnInit() {
    }

    changLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    getUrl(item: DocumentItem, lang: string = 'en'): string {
        let url = ''
        if (lang === 'en' && item.url_en) {
            url = item.url_en
        } else if (lang === 'ja' && item.url_ja) {
            url = item.url_ja
        } else {
            url = item.url
        }
        return url
    }
}

interface DocumentItem {
    name: string,
    url?: string,
    url_en?: string,
    url_ja?: string,
    icon?: string,
    text?: string,
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/document/document.component.ts